export default "__VITE_ASSET__Dd6epg4g__"